import { KAMBI_ROOT_ROUTE } from '@core/Areas/KambiClient/constants'

export const getEventLink = (eventId: number) => {
  return `/${KAMBI_ROOT_ROUTE}/event/${eventId}`
}
